import { render, staticRenderFns } from "./NewBarrier.vue?vue&type=template&id=5908b527&scoped=true"
import script from "./NewBarrier.vue?vue&type=script&lang=js"
export * from "./NewBarrier.vue?vue&type=script&lang=js"
import style0 from "./NewBarrier.vue?vue&type=style&index=0&id=5908b527&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5908b527",
  null
  
)

export default component.exports